import React from "react";

import { TextField } from "@fluentui/react";
import { IQuestionControlProps } from "shared/containers";

export const TextFieldControl: React.FC<IQuestionControlProps> = (props) => {
	const {
		dataId,
		parentId,
		disabled,
		formId,
		fieldId,
		label,
		value,
		valueId,
		fieldAttribute,
		fieldType,
		errorMessage,
		onChange,
	} = props;

	const onValueChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		if (onChange)
			onChange(
				parentId,
				fieldId,
				formId,
				fieldAttribute,
				fieldType,
				event.target.value,
				valueId,
				dataId
			);
	};
	return (
		<div className="form-group">
			{label && <label>{label}</label>}
			<input
				className="form-control"
				value={value}
				disabled={disabled}
				onChange={onValueChange}
			/>
		</div>
	);
	// return (
	// 	<TextField
	// 		label={label}
	// 		value={value}
	// 		disabled={disabled}
	// 		errorMessage={errorMessage}
	// 		onChange={onValueChange}
	// 	/>
	// );
};
